// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"4f4acc04","712":"85c1f362"}[chunkId] + ".chunk.js";
};